import {IGradesService} from './IGradesService';
import {GradesRepository} from './GradesRepository';
import {
  CreateNewGradeInput,
  UpdateNewGradeInput,
} from '@PikaDoApp/npm-pikado-logic';
import {GradeUI} from './GradeTypes';

export class GradesService implements IGradesService {
  gradesRepository: GradesRepository;
  constructor() {
    this.gradesRepository = new GradesRepository();
  }

  async getGrades(): Promise<Array<GradeUI>> {
    let grades = await this.gradesRepository.getGrades();
    return grades;
  }

  async getNewGradeById(id: string): Promise<GradeUI | null> {
    const grade = await this.gradesRepository.getNewGradeById(id);
    return grade;
  }

  async createNewGrade(input: CreateNewGradeInput): Promise<GradeUI | null> {
    const createdGrade = await this.gradesRepository.createNewGrade(input);
    return createdGrade;
  }

  async updateNewGrade(input: UpdateNewGradeInput): Promise<GradeUI | null> {
    const updatedGrade = await this.gradesRepository.updateNewGrade(input);
    return updatedGrade;
  }

  async deleteNewGrade(id: string): Promise<any> {
    const result = await this.gradesRepository.deleteNewGrade(id);
    return result;
  }
}
